import * as React from 'react';

function Svg16Copy( props ){
  return (
    <svg
      width={ 16 }
      height={ 16 }
      { ...props }
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.638 2.787v.596h2.383c.333 0 .596.263.596.596v1.787h.596V3.979c0-.655-.537-1.192-1.192-1.192zM2.191 2.787C1.537 2.787 1 3.324 1 3.98v9.83C1 14.463 1.537 15 2.191 15h3.575v-.596H2.191a.591.591 0 0 1-.595-.595v-9.83c0-.333.263-.596.595-.596h2.383v-.596Z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M4.599 1c-.5 0-.865.507-.706.98l.595 1.788a.747.747 0 0 0 .707.509h3.823c.32 0 .605-.206.706-.509l.596-1.787A.752.752 0 0 0 9.614 1H4.6Zm-.001.596h5.017c.11 0 .176.09.14.195v.001L9.16 3.58a.147.147 0 0 1-.142.1H5.195a.147.147 0 0 1-.142-.1l-.596-1.788c-.035-.105.03-.197.14-.196ZM8.447 7.255c-.655 0-1.192.537-1.192 1.192v5.362c0 .654.537 1.191 1.192 1.191h5.362c.654 0 1.191-.537 1.191-1.191V8.447c0-.655-.537-1.192-1.191-1.192Zm0 .596h5.362c.335 0 .595.26.595.596v5.362c0 .335-.26.595-.595.595H8.447a.588.588 0 0 1-.596-.595V8.447c0-.335.26-.596.596-.596z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M9.34 9.043v.595h3.575v-.595ZM9.34 10.83v.596h3.575v-.596zM9.34 12.617v.596h1.34v-.596z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
    </svg>
  );
}

export default Svg16Copy;
